import React from "react";
import { Paginator } from "primereact/paginator";
import { PaginationContainer } from "styles/components/usersList.styles";

interface UsersPaginationProps {
  currentPage: number;
  pageSize: number;
  totalRecords: number;
  onPageChange: (event: { first: number; rows: number; page: number }) => void;
  showPagination: boolean;
}

const UsersPagination: React.FC<UsersPaginationProps> = ({
  currentPage,
  pageSize,
  totalRecords,
  onPageChange,
  showPagination,
}) => {
  if (!showPagination) {
    return null;
  }

  return (
    <PaginationContainer>
      <Paginator
        first={(currentPage - 1) * pageSize}
        rows={pageSize}
        totalRecords={totalRecords}
        rowsPerPageOptions={[10, 20, 50]}
        onPageChange={onPageChange}
        template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      />
    </PaginationContainer>
  );
};

export default UsersPagination;
